import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import styled from 'styled-components';
import { ContentType } from '../SectionWrapper/SectionWrapper';
const Container = styled.section `
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px;
`;
const Tag = styled.p `
  ${fonts.proximaNova.semiBold};

  --iconColour: ${brand.green.default};

  ${Container}[data-type=${ContentType.Intermediaries}] & {
    --iconColour: ${brand.blue.navy};
  }

  ${Container}[data-type=${ContentType.Savings}] & {
    --iconColour: ${brand.blue.default};
  }

  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 12px;
  color: ${brand.blue.dark};
  padding: 8px 12px;
  border-radius: 30px;
  border: 1px solid ${brand.global.beige};
  background-color: ${brand.global.beige};

  &:has(svg) {
    padding-left: 16px;
    padding-right: 16px;
    border-color: ${brand.grey.light};
    background-color: transparent;
  }

  svg {
    display: block;
    width: 12px;
    color: var(--iconColour);
  }
`;
const ArticleTagsStyles = {
    Container,
    Tag,
};
export default ArticleTagsStyles;
